import React from 'react';
import Booking from '../Booking/Booking';
import Sidebar from '../Sidebar/Sidebar';

const Dashboard = () => {
    return (
        <div>
            <Sidebar/>
            <Booking/>
        </div>
    );
};

export default Dashboard;